document.addEventListener('DOMContentLoaded', () => {
  // Clean up empty paragraphs and whitespace-only/nbsp-only paragraphs in RTE content
  const rteContent = document.querySelector('.rte');
  if (rteContent) {
    const paragraphs = rteContent.querySelectorAll('p');
    paragraphs.forEach(p => {
      // Strip out non-breaking spaces (\u00a0) and standard whitespaces
      const cleanText = p.textContent.replace(/[\s\u00a0]/g, '');
      const hasOnlyBrs = p.children.length > 0 && Array.from(p.childNodes).every(node => {
        return node.nodeName === 'BR' || (node.nodeType === 3 && !node.textContent.replace(/[\s\u00a0]/g, ''));
      });
      
      if (cleanText === '' && (p.children.length === 0 || hasOnlyBrs)) {
        p.style.setProperty('display', 'none', 'important');
        p.style.setProperty('margin', '0', 'important');
        p.style.setProperty('padding', '0', 'important');
        p.style.setProperty('height', '0', 'important');
      }
    });
  }

  const checkCommentRedirect = () => {
    if (window.location.hash === '#comments' || window.location.search.includes('comment_posted=true')) {
      const commentsSection = document.getElementById('comments');
      if (commentsSection) {
        commentsSection.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  checkCommentRedirect();
});
